<template>
    <div class="parent">
      <v-alert
        class="mx-1"
        :value="true"
        color="warning"
        dense
        border="top"
        v-if="isCurrentVerion"
        >
        There is a <a :href="getDeptictionURLCurrent()">newer version </a> of the record available.
      </v-alert>
      <ResponsiveDesignLayer :isMedia="isMedia" :hasImage="image ? true : false" @isFlipped="resize" >
      <template v-slot:left-column>
        <kuchaStudiesPDFVIew v-if="image && image.isLKS" :leipzigKuchastudiesEntry="image.LKS"/>
        <div class="flex-grow"  v-if="image && image.is3D && relatedDepictionsLoaded">
          <Cave3DModelInf class="flex-grow" :elementID="'cave3DModel-' +  pr.cave.caveID"  :item="pr" :relatedDepictions="relatedDepictions" :fokusOnFirstDepiction="true" />
        </div>
        <AnnotatedImageView
          v-if="images.length > 0 && image && !image.is3D && isImageSet && !image.isLKS"
          @annoHover="annoHover"
          @annoHoverOut="annoHoverOut"
          :image="image"
          :isImageValid="isImageValid(image.imageID)"
          ref="annoImg"
          :highlightedAnnotations="highlightedAnnotations"
          :hideTree="true"
          v-show="showAnno"
          :item="pr"
          :annos="annos"
          :relatedAnnotations="pr.relatedAnnotationList"
          :isVersion="version"
          :highlightedIcos="highlightedIcos"
          @icoSelectedChanged="icoSelectedChanged"
          @hoveredItemChanged="hoveredItemChanged"
          @selectedAnnosChanged="selectedAnnosChanged"
          @setHighlightedIcos="setHighlightedIcos"
        />
        <v-tabs ref="tabs"
          class="mx-1 px-3 pt-1 my-1"
          v-if="images.length > 1"
          v-model="imageTab"
          :key="tabKey"
          centered
          light
          slider-color="primary"
          return-object
          style="color:rgba(255, 255, 255, 0.2) !important;flex:0"
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          show-arrows

        >
          <v-tab
            v-for="(item, index) in images"
            :key="index"
            @click="setImage(item)"
            style="color:gba(255, 255, 255, 0.2) !important;"
            :class="{
              'highlighted': true,
              'highlighted-active':
                icoSelected.some(a =>
                  Array.isArray(a.w3cAnno) &&
                  a.w3cAnno.some(w => w.target?.source === item.filename)
                ) ||
                (
                  Array.isArray(hoveredItem) &&
                  hoveredItem.length > 0 &&
                  hoveredItem.some(w => w.image === item.filename)
                )
            }"
          >
          <v-icon x-large v-if="item && item.is3D">
              mdi-rotate-3d
            </v-icon>

            <v-icon x-large v-else-if="item && item.isLKS">
              mdi-book-open-variant-outline
            </v-icon>

            <v-img  v-else-if="(imageValidDic[item.imageID]) ? imageValidDic[item.imageID].valid: false"
              :src="imageValidDic[item.imageID].thumbnail"
            >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="grey-lighten-4"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
            </v-img>
            <v-icon x-large v-else>mdi-lock</v-icon>
          </v-tab>
        </v-tabs>
      </template>
      <template v-slot:right-column>
        <div class="text-overline grey--text text--darken-1 px-2 pt-2 mb-n2" style="line-height: 1; letter-spacing: 0.08em;">
          Painted Representation
        </div>
        <v-card-title class="text-h6 mx-0 px-2 pt-2 font-weight-bold" style="display: inline-block; line-height: 1.3;" >
          {{getDepictionLabel()}}
        </v-card-title>
          <v-sheet v-if="!isMobile()" class="sticky-header-bar">
            <v-btn
              v-for="(item_value, item_name, item_key) in depictionInfo"
              :key="item_key"
              small
              text
              class="mx-1"
              @click="scrollToSection(item_key)"
            >
              {{ item_name }}
            </v-btn>
          </v-sheet>
          <div style="position: relative;">
            <v-alert
              ref="top-hint"
              v-if="showTopHint"
              type="info"
              dense
              density="compact"
              color="primary"
              icon="mdi-arrow-up"
              :class="['mb-n15', 'hint-alert', { 'fade-out': fadingOut }]"
            >
              scroll up for more info
            </v-alert>
          </div>
          <div ref="scroll-container" class="mx-1 scroll-content">
            <div
                v-for="(item_value, item_name, item_key) in depictionInfo"
                :key="item_key"
                :ref="'section-' + item_key"
              >
              <div class="mx-1 mt-2 caption_dotted">
                {{item_name}}
              </div >
              <AnnotatedImageTree
                ref="annoTree"
                v-if="item_name === 'Annotations'"
                :annos="annos"
                :relatedAnnotations="pr.relatedAnnotationList"
                :highlightedIcos="highlightedIcos"
                :preselectedIcos="preselectedIcos"
                @mouseOverNode="mouseOverNode"
                @mouseLeaveNode="mouseLeaveNode"
                @clickAnno="clickAnno"
              ></AnnotatedImageTree>
              <div v-if="item_name === 'Interpretation Proposed by the Project'" class="mx-2">
                <SuggestedInterpretation v-for="suggestedInterpretation in pr.suggestedInterpretationList" :key="suggestedInterpretation.suggestedInterpretationID" :item="pr" :suggestedInterpretation="suggestedInterpretation"/>
              </div>
              <div v-if="item_name=='Related Chronological Discussions'">
                <foruminf heading="Related Chronological Discussions" :newPosts="false" @getComments="getComments()" :discussions="discussions" :chronologicalRange="getChronologicalRange"></foruminf>
              </div>

                <div v-for="(value, name, index) in item_value" :key=index >
                  <div class="py-1" style="display:inline-block">
                    <div v-if="(name !== 'Copyright' && name !== 'Wall Location' && name !== 'Related Chronological Discussions' && name !== 'Cave' && name !== captionOtherPaintings)" style="display: inline-block; white-space: normal;">
                      <template v-if="name === 'Name'">
                        {{ value }}
                      </template>
                      <template v-else>
                        <span >{{ name }}:</span>
                         <a  v-if="name === 'Source URL'" class="list-item-value" :href="value" target="_blank" rel="noopener noreferrer">{{ value }} </a>
                         <div v-else class="list-item-value"> {{ value }} </div>
                      </template>
                    </div>
                    <div v-if="(name === 'Copyright')" style="display: inline-block;white-space: normal" v-html="name + ': ' + value"></div>
                    <div v-if="name === 'Cave'" style="display: inline-block;"> <a target=”_blank” :href="getCaveURL()">{{ getCaveLabel(value) }}</a> </div>

                    <v-treeview class="mx-3"
                          open-all
                          ref="wallTree"
                          v-if="name === 'Wall Location'"
                          :items="value"
                      ></v-treeview>

                  </div>

                </div>
                  <div v-if="relatedDepictionsByImage.length > 0 && item_name === 'Shown Image'" class="mt-2">
                    <div class="accordion">
                      <div
                        @click="isGridVisible = !isGridVisible"
                        class="accordion-header"
                      >
                        <span style="font-weight: 100;" >Also Used In</span>
                        <svg
                          class="chevron"
                          :class="{ 'chevron-open': isGridVisible }"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </div>

                      <div class="accordion-grid" :class="{ 'is-open': isGridVisible }">
                        <div class="accordion-grid-inner">

                          <lazyTileGrid
                            v-if="isGridVisible"
                            :centered="true"
                            @loadMore="getNextResults"
                            :items="relatedDepictionsByImage"
                            :itemsCount="10"
                          ></lazyTileGrid>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="item_name === 'Bibliography'" class="mx-5">
                  <v-list-item>
                    <v-list-item-content>
                      <div class="mb-2" v-for="annotatedBibliography in pr.relatedBibliographyList" :key="annotatedBibliography.annotatedBibliographyID">
                        <a v-if="bibliographyHasLink(annotatedBibliography)" target=”_blank”   :href="getBibUrl(annotatedBibliography)" v-html="getBibTitle(annotatedBibliography)"></a>
                        <div v-else v-html="getBibTitle(annotatedBibliography)"> </div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>

                </div>
              <div v-if="item_name === captionOtherPaintings" class="mx-2">
              <div class="lazy-grid-wrapper">
               <lazyTileGrid :centered="true" @loadMore="getNextResults" :items="relatedDepictions" :itemsCount="resAmount" ></lazyTileGrid>
              </div>
              </div>


              </div>
              <div class="mx-1 caption_dotted">
                Versions
              </div >
              <div v-show="versions.length>1">
                <v-combobox
                  class="d-flex justify-center align-center mx-8"
                  v-model="version"
                  :items="versions"
                  label="Select Version"
                  outlined
                  dense
                  item-text = "date"
                  item-value="_id"
                ></v-combobox>
              </div>
        </div>
        <div style="position: relative;">
            <v-alert
              ref="top-hint"
              v-if="showBottomHint"
              type="info"
              dense
              density="compact"
              color="primary"
              icon="mdi-arrow-down"
              :class="['mt-n15', 'hint-alert', { 'fade-out': fadingOut }]"
            >
              scroll down for more info
            </v-alert>
          </div>
      </template>
      </ResponsiveDesignLayer>
    </div>
</template>

<script>
import caveInf from '@/components/caveInf'
import {getBibTitle, getLeipzigKuchastudiesEntries, getCaveLabel, getWallTreeByIDs, getDepictionLabel, getTagIDsFromRelatedAnnotations, getChronologicalRange, getWallIDsInRegisterSystem, setOSDImgInfo, bibliographyHasLink, getCaveShortLabel} from  "@/utils/helpers"
import {getDepictionsByImageID, getVersionsOfEntry, getVersionOfEntry, getWallTreeByTimestamp, getCommentsByItems, getItemById} from '@/services/repository'
import Foruminf from '../components/foruminf.vue'
import Cave3DModelInf from '../components/cave3DModelInf.vue'
import kuchaStudiesPDFVIew from '../components/leipzigKuchaStudiesPDFView.vue'
import osdImgViewer from '../components/osdImgViewer.vue'
import SuggestedInterpretation from '../components/SuggestedInterpretation.vue'
import AnnotatedImageTree from './AnnotatedImageTree.vue'
import AnnotatedImageView from './AnnotatedImageView.vue'
import ResponsiveDesignLayer from './ResponsiveDesignLayer.vue'
import { isMobile } from '../utils/helpers'
import lazyTileGrid from './lazyTileGrid.vue'


export default {

  name: 'depictionInf',
  components: {
    caveInf,
    AnnotatedImageView,
    Foruminf,
    osdImgViewer,
    kuchaStudiesPDFVIew,
    Cave3DModelInf,
    SuggestedInterpretation,
    AnnotatedImageTree,
    ResponsiveDesignLayer,
    lazyTileGrid,

  },
  props: {
    depiction: {},
    presentCave:true,
  },
  data () {
    return {
      pr:{},
      relatedDepictions: [],
      relatedDepictionsLoaded: false,
      isFullScreen: false,
      isDrawing:false,
      showAnno:true,
      showKuchaStudies: true,
      tab:[],
      tabKey:0,
      showDescription: false,
      image:{},
      imageTab:0,
      show3DModel:false,
      showCave: false,
      showImage: false,
      hideAnno:false,
      tabItems: [],
      annos : [],
      images : [],
      viewerImg :null,
      viwerAnnos:null,
      annoPermanentSelected: [],
      selectType:"leaf",
      idName:"iconographyID",
      dialog:false,
      isAllowedPic:true,
      version:null,
      versions:['current'],
      showVersions: false,
      walllTree: [],
      walls:[],
      discussions: [],
      mouseWheelOverlay: false,
      showSuggestedInterpretation: false,
      isVisible: false,
      lastBounding: null,
      showTopHint: false,
      showBottomHint: false,
      hintTimeoutId: null,
      captionOtherPaintings: "placeholder",
      fadingOut: false,
      icoSelected:[],
      hoveredItem: null,
      highlightedAnnotations: [],
      highlightedIcos: [],
      preselectedIcos: [],
      annotationIDAnnotoriousIDMap:{},
      annotoriousIDAnnotationIDMap:{},
      preselectedIcos: [],
      resAmount: 0,
      relatedDepictionsByImage: [],
      isGridVisible: false
    }
  },
  computed:{
    isMedia(){
      for (const image of this.images){
        if (image.is3D || image.isLKS){
          return true
        }
      }
      return false
    },
    isImageSet(){
      this.$log.debug("isImageSet:", this.image);
      return Object.keys(this.image).length > 0
    },
    imageValidDic (){
      return this.$store.getters.getImageValidDic ? this.$store.getters.getImageValidDic : {}
    },
    isLocatedInCave(){
      for (const wall of this.pr.cave.wallList){
        for (const wallDimension of wall.wallDimensions){
          for (const coordinate of wallDimension.coordinates){
            if (coordinate.depictionID === this.pr.depictionID){
              return true

            }
          }
        }
      }
      return false
    },
    user () {
      return this.$store.state.user
    },
    highlightedImages() {
      const child = this.$refs['annoImg']
      if (!child) return []
      return child.annos.map(a => a.imageID)
    },
    isCurrentVerion(){
      if (this.$route.params.version === "current"){
        return false
      }
      return parseInt(this.$route.params.version) < this.versions.length - 1
    },
    getChronologicalRange(){
      return getChronologicalRange()
    },
    depictionInfo(){
      var depictionInf = {}
      var mainInf = {}
      if (Object.keys(mainInf).length > 0){
        depictionInf['Main'] = mainInf
      }
      if (this.pr.location){
        let currentLocation = ""
        if (this.pr.location.name){
          currentLocation = this.pr.location.name
        }
        if (this.pr.location.town){
          currentLocation += ", " + this.pr.location.town
        }
        if (this.pr.location.country){
          currentLocation += ", " + this.pr.location.country
        }
        if (this.pr.location.region){
          currentLocation += ", " + this.pr.location.region
        }
        if (this.pr.location.url){
          currentLocation += ", " + ", URL: " + this.pr.location.url
        }
        depictionInf['Current Location'] = {}
        if (currentLocation !== ""){
          depictionInf['Current Location']["Name"] = currentLocation
        }
        if (this.pr.expedition){
          depictionInf['Current Location']['Acquired by expedition'] = this.pr.expedition.name
        }
        if (this.pr.vendor){
          depictionInf['Current Location']['Vendor'] = this.pr.vendor.vendorName
        }
        if (this.pr.purchaseDate){
          depictionInf['Current Location']['Date purchased'] = this.pr.purchaseDate
        }
        if (this.pr.inventoryNumber){
          depictionInf['Current Location']['Inventory Number'] = this.pr.inventoryNumber
        }
      }


      var wallLocation = {}
      if (this.pr.cave){
        wallLocation["Cave"] = this.pr.cave
      }
      this.$log.debug("wallIDs", this.pr.wallIDs);
      if (this.pr.wallIDs){
        wallLocation["Wall Location"] = this.walls
      }
      if (this.pr.positionNotes){
        wallLocation["Position Notes"] = this.pr.positionNotes
      }
      if (Object.keys(wallLocation).length > 0){
        depictionInf["Location in Cave"] = wallLocation
      }
      if (this.image){
        if (!this.image?.is3D && !this.image?.isLKS){
          depictionInf["Shown Image"] = {
            // "Title": this.image.title,
            "Filename": this.image.filename,
            "Copyright": (this.image.cc ? this.image.copyright + "<br>" + this.image.cc.html : this.image.copyright)
          }
          if (this.image.location){
            let location = this.image.location.name
            if (this.image.location.town){
              location += ", " + this.image.location.town
            }
            if (this.image.location.country){
              location += ", " + this.image.location.country
            }
            depictionInf["Shown Image"]["Location"] = location
          }
          if (this.image.date){
            depictionInf["Shown Image"]["Date"] = this.image.date
          }
          if (this.image.comment && this.image.comment !== undefined && this.image.comment !== ""){
            depictionInf["Shown Image"]["Comment"] = this.image.comment
          }
          if (this.image.inventoryNumber && this.image.inventoryNumber !== undefined && this.image.inventoryNumber !== ""){
            depictionInf["Shown Image"]["Inventory Number"] = this.image.inventoryNumber
          }
          if (this.image.inventoryNumber && this.image.inventoryNumber !== undefined && this.image.inventoryNumber !== ""){
            depictionInf["Shown Image"]["Inventory Number"] = this.image.inventoryNumber
          }
          if (this.image.url && this.image.url !== undefined && this.image.url !== ""){
            depictionInf["Shown Image"]["Source URL"] = this.image.url
          }
        }
      }

      var depictionDes = {}
      if (this.pr.width){
        depictionDes["Width"] = this.pr.width
      }
      if (this.pr.height){
        depictionDes["Height"] = this.pr.height
      }
      if (this.pr.style){
        depictionDes["Style"] = this.pr.style.styleName
      }
      if (this.pr.modeOfRepresentation){
        depictionDes["Mode of Representation"] = this.pr.modeOfRepresentation.name
      }
      if (this.pr.backgroundColour){
        depictionDes["Background Colour"] = this.pr.backgroundColour
      }
      if (this.pr.inscriptions){
        depictionDes["Inscriptions"] = this.pr.inscriptions
      }
      if (this.pr.separateAksaras){
        depictionDes["Separate Akṣaras"] = this.pr.separateAksaras
      }
      if (this.pr.dating){
        depictionDes["Related Chronological Discussions"] = this.pr.dating
      }
      if (this.pr.description){
        depictionDes["Description"] = this.pr.description
      }
      if (this.pr.generalRemarks){
        depictionDes["General Remarks"] = this.pr.generalRemarks
      }
      if (this.pr.otherSuggestedIdentifications){
        depictionDes["Other Suggested Identifications"] = this.pr.otherSuggestedIdentifications
      }
      if (Object.keys(depictionDes).length > 0){
        depictionInf["Description"] = depictionDes
      }
      if (this.pr.suggestedInterpretationList){
        if (this.pr.suggestedInterpretationList?.length > 0){
          depictionInf["Interpretation Proposed by the Project"] = {}
        }
      }
      if (this.pr.relatedAnnotationList?.length > 0){
        depictionInf["Annotations"] = {}
      }

      if (this.discussions.length > 0){
        depictionInf['Related Chronological Discussions'] = {}
      }
      if (this.pr.relatedBibliographyList){
        if (this.pr.relatedBibliographyList?.length > 0){
          depictionInf["Bibliography"] = {}
        }
      }
      this.$log.debug("depictionInf", depictionInf);
      if (this.relatedDepictions.length > 0){
        this.captionOtherPaintings = 'Other Paintings from ' + getCaveShortLabel(this.pr.cave)
        depictionInf[this.captionOtherPaintings] = ''
      }

      return depictionInf
    },

  },

  methods: {

    getNextResults(from, size){

    },
    setHighlightedIcos(newVal){
      this.$log.debug("setHighlightedIcos in depictionInf", newVal);
      this.highlightedIcos = newVal
    },
    selectedAnnosChanged(newVal){

      this.$router.replace({
        query: {
          ...this.$route.query,
          annotation: newVal.map(x => this.annotoriousIDAnnotationIDMap.get(x.id))
        }
      }).catch(() => {}); // optional, um den Promise-Abbruch zu ignorieren
    },
    hoveredItemChanged(newVal){
      this.$log.debug("hoveredItemChanged in depictionInf", newVal);
      this.hoveredItem = newVal
    },
    icoSelectedChanged(newVal){
      this.$log.debug("icoSelectedChanged in depictionInf", newVal);
      this.icoSelected = newVal
      this.$router.replace({
        query: {
          ...this.$route.query,
          iconography: newVal.map(x => x.id)
        }
      }).catch(() => {}); // optional, um den Promise-Abbruch zu ignorieren

    },
    getRelatedDepictions(){
      this.relatedDepictions = []
      this.$log.debug("showing depictions enabled. sending request now.")
      let params = {}
      if (this.pr.cave.caveID){
        params['id'] = this.pr.cave.caveID
        params['type'] = "cave.caveID"
        const _self = this
        getItemById(params)
          .then( res => {
            for (let result of res.data.hits.hits){
              if (result._source.depictionID !== this.pr.depictionID) _self.relatedDepictions.push(result._source)
            }
            _self.resAmount = res.data.hits.total.value
            _self.$log.debug("recieved depictions.", _self.relatedDepictions)
            _self.relatedDepictionsLoaded = true
            _self.depictionInfo
          }).catch(function (error) {
            this.$log.debug(error)
            _self.relatedDepictionsLoaded = true
          })
      }
    },
    isMobile(){
      return isMobile()
    },
    bibliographyHasLink(bib){
      return bibliographyHasLink(bib)
    },
    getBibUrl(bib){
      if (bib.uri){
        return bib.uri
      }
      if (bib.url){
        return bib.url
      }
      return ""
    },

    getBibTitle(bib){
      return getBibTitle(bib)
    },
    scrollToSection(key) {
      this.$nextTick(() => {
        const section = this.$refs['section-' + key];
        if (section && section[0]) {
          section[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    setImage(image){
      this.image = image

      this.$log.debug("set image", image)
      if (image !== undefined && this.$route.query.image !== image?.imageID) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            image: image.imageID
          }
        }).catch(() => {}); // optional, um den Promise-Abbruch zu ignorieren
      }
    },
    setOSDImgInfo(image){
      return setOSDImgInfo(image)
    },
    isImageValid(imageID){
      this.$log.debug("isImageValid", imageID, this.$store.getters.getImageValidDic, this.$store.getters.getImageValidDic[imageID]?.valid)
      if (this.$store.getters.getImageValidDic){
        if (this.$store.getters.getImageValidDic[imageID]){
          return this.$store.getters.getImageValidDic[imageID].valid
        }
      }
      return false
    },
    annoHover(annotation){
      if (this.hintTimeoutId) {
        clearTimeout(this.hintTimeoutId)
        this.hintTimeoutId = null
      }
      this.$log.debug("annoHover", annotation, this.$refs)
      const treeElement = this.$refs['annoTree'][0].mouseEnterAnnotation(annotation)
      const container = this.$refs['scroll-container'];
      const topHint = this.$refs['top-hint'];
      const bottomHint = this.$refs['bottom-hint'];
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          this.isVisible = entry.isIntersecting;
          this.lastBounding = entry.boundingClientRect;
        },
        {
          root: container,
          threshold: 0.01, // Trigger schon bei kleinstem Teil sichtbar/nicht sichtbar
        }
      );
      observer.observe(treeElement);
      // topHint.style.display = 'none';
      // bottomHint.style.display = 'none';
      if (!this.isVisible && this.lastBounding) {
        const containerRect = container.getBoundingClientRect();

        if (this.lastBounding.top < containerRect.top) {
          // Element ist nach oben raus
          // topHint.style.display = 'block';
          this.$log.debug("topHint", topHint)
          this.showTopHint = true
        } else if (this.lastBounding.bottom > containerRect.bottom) {
          this.$log.debug("bottomHint", bottomHint)
          this.showBottomHint = true
          // Element ist nach unten raus
          // bottomHint.style.display = 'block';
        }
      }
      this.hintTimeoutId = setTimeout(() => {
        this.fadeOutHint(); // separate Funktion, siehe unten
      }, 2000)

      this.$log.debug("treeElement depiction", treeElement, this.isVisible, this.lastBounding)
    },
    fadeOutHint() {
      this.fadingOut = true;
      setTimeout(() => {
        this.showTopHint = false;
        this.showBottomHint = false;
        this.fadingOut = false;
      }, 1000); // Dauer des Fade-Out
    },
    annoHoverOut(annotation){
      this.$log.debug("annoHoverOut", annotation, this.$refs)
      this.$refs['annoTree'][0].mouseOutAnnotation(annotation)
    },
    mouseOverNode(item){
      this.$log.debug("mouse over!", item)
      this.$refs['annoImg']?.mouseOverNode(item)
    },
    mouseLeaveNode(item){
      this.$log.debug("mouse leave!", item)
      this.$refs['annoImg']?.mouseLeaveNode(item)
    },
    clickAnno(item){
      this.$log.debug("clickAnno in depictionInf!", item)
      this.$refs['annoImg'].seticoSelected(item)
    },
    getLeipzigKuchastudiesEntries(bibEntry){
      var leipzigKuchastudiesEntries = getLeipzigKuchastudiesEntries(bibEntry)
      return leipzigKuchastudiesEntries
    },
    getComments(){
      getCommentsByItems(this.pr.cave ? [this.pr.cave.caveID] : [], [this.pr.depictionID], getTagIDsFromRelatedAnnotations(this.pr.relatedAnnotationList), [])
        .then( res => {
          this.$log.debug("recieved discussions.", res.data.hits.hits)
          this.discussions = res.data.hits.hits
        }).catch(function (error) {
          this.$log.debug(error)
          return null
        })
    },
    initWalls(){
      var walls = this.pr.wallIDs.concat(getWallIDsInRegisterSystem(this.pr.cave, this.pr.depictionID));
      this.$log.debug("initWalls", walls);
      if (this.version.date.toString().includes('current')){
        this.walls = getWallTreeByIDs(walls, this.$store.state.wallLocation, this.pr.depictionID)
      } else {
        this.walls = getWallTreeByIDs(walls, this.wallTree, this.pr.depictionID)
      }
      this.$log.debug("initWalls result", this.walls)
      if (this.$refs['wallTree']) {
        this.$log.debug("this.$refs['wallTree']", this.$refs['wallTree']);
        this.$refs['wallTree'][0].updateAll(true)
      }
    },
    getDeptictionURL(){
      if (this.pr){
        if (Object.keys(this.pr).length > 0){
          this.$log.debug("getDeptictionURL: ", this.pr.depictionID, this.versions.indexOf(this.version));
          return "/pr/" + this.pr.depictionID + "/" + (this.versions.indexOf(this.version) + 1 === this.versions.length ? "current" : this.versions.indexOf(this.version) + 1)
        }
      }
      return "/pr/"
    },
    getCaveURL(){
      if (this.pr.cave){
        if (Object.keys(this.pr.cave).length > 0){
          return "/cave/" + this.pr.cave.caveID
        }
      }
      return ""
    },
    getDeptictionURLCurrent(){
      if (this.pr){
        if (Object.keys(this.pr).length > 0){
          return "/pr/" + this.pr.depictionID + "/current"
        }
      }
      return "/pr/"
    },
    getDepictionLabel(){
      if (this.pr){
        if (Object.keys(this.pr).length > 0){
          return getDepictionLabel(this.pr)
        }
      }
      return ""

    },
    initNewDepiction(){
      if (this.pr){
        this.pr = this.depiction
        this.annotationIDAnnotoriousIDMap = new Map(
          this.pr.relatedAnnotationList.map(x => [x.annotationID, x.annotoriousID])
        );
        this.annotoriousIDAnnotationIDMap = new Map(
          this.pr.relatedAnnotationList.map(x => [x.annotoriousID, x.annotationID])
        );
        this.$log.debug("started Depiction");
        this.$log.debug("Depiction: ", this.pr);
        getVersionsOfEntry(this.pr)
          .then( res => {
            this.$log.debug("recieved versions.", res)
            this.versions = res.data.hits.hits
            for (let v of this.versions){
              v.date = new Date(v._source.timestamp)
            }
            if (this.versions.length){
              this.versions[this.versions.length - 1].date = this.versions[this.versions.length - 1].date + " - (current)"
              let currentVersion = JSON.parse(JSON.stringify(this.versions[this.versions.length - 1]))
              currentVersion._id = "current"
              currentVersion.date = "link which always points to current version"
              this.versions.push(currentVersion)
              this.version = this.versions[this.versions.length - 1]
            }
            if (this.$route.params.version){
              if (this.$route.params.version !== "current"){
                const versionNumber = parseInt(this.$route.params.version) || this.versions.length - 1
                this.$log.debug("version number init: ", versionNumber, this.$route.params.version);
                this.version = this.versions[versionNumber - 1]
                this.setVersion(this.version)
              } else {
                this.version = this.versions[this.versions.length - 1]
                this.initWalls()
              }
            } else {
              this.initWalls()
            }
          }).catch(function (error) {
            console.log(error)
            return null
          })
        this.fillPicsContainer()
        this.$log.debug("Annos:", this.annos);
        this.$log.debug("Images:", this.images);
        this.tabItems = []
        this.tabItems.push.apply(this.tabItems, this.images)
        var found = null
        this.$log.debug("this.$route.query: ", this.$route.query);
        if (this.$route.query.image) {
          found = this.images.find(img => img.imageID === this.$route.query.image || img.imageID === Number(this.$route.query.image));
          this.$log.debug("found preselected image: ", found, this.images.toString);
          if (found) {
            this.setImage(found)
          }
        }
        if (this.$route.query.annotation) {
          const queryAnnotations = Array.isArray(this.$route.query.annotation)
            ? this.$route.query.annotation
            : [this.$route.query.annotation];

          // Hole die passenden annotoriousIDs:
          this.highlightedAnnotations = queryAnnotations
            .map(id => this.annotationIDAnnotoriousIDMap.get(parseInt(id)))
            .filter(id => id !== undefined);

          this.$log.debug("found preselected annotation:", queryAnnotations ,this.highlightedAnnotation, this.annotoriousIDAnnotationIDMap, this.annotationIDAnnotoriousIDMap,
            this.pr.relatedAnnotationList.filter(item =>
              queryAnnotations.includes(item.annotationID))
          );        }
        if (this.$route.query.iconography) {
          this.$log.debug("found preselected iconography: ", this.$route.query);
          const preselectedIcosIDs = Array.isArray(this.$route.query.iconography) ? this.$route.query.iconography : [this.$route.query.iconography]
          this.$log.debug("preselectedIcosIDs: ", preselectedIcosIDs, this.icoAnnos);
          this.preselectedIcos = preselectedIcosIDs
          this.$log.debug("found preselected iconography: ", this.preselectedIcos)
        }
        if (!found) {
          this.image = this.images.find(element => element.imageID === this.pr.masterImageID)
          if (!this.image) {
            this.$log.debug("masterimage not found: ", this.images);
            const image = this.images.find(element => element.is3D || element.isLKS)
            this.setImage(image)
          } else {
            if (this.images.length > 1) {
              this.setImage(this.images[0])
            }
          }
        }
        this.imageTab = this.images.indexOf(this.image)
      }
      if (this.$refs['wallTree']) {
        this.$refs['wallTree'][0].updateAll(true)
      }

    },
    test(item){
      this.$log.debug("clicked: ", item);
      this.$log.debug("icoSelected: ", this.icoSelected);
    },
    mouseOver: function(){
      this.showDescription = !this.showDescription
    },
    getCaveLabel(entry){
      if (entry !== undefined){
        return getCaveLabel(entry)
      } else {
        return "";
      }
    },
    resize(){
      if (this.$refs['annoImg']){
        this.$refs['annoImg'].resize();
      }
    },
    fillPicsContainer(){
      this.annos = []
      this.images = []
      for (var img of this.pr.relatedImages){
        if (this.pr.relatedAnnotationList.find(element => element.image === img.filename)) {
          this.annos.push(img)
          this.images.push(img)
        } else {
          this.images.push(img)
        }
      }
this.images.sort((a, b) => {
        // 1. Master immer ganz vorne
        if (a.imageID === this.pr.masterImageID) return -1;
        if (b.imageID === this.pr.masterImageID) return 1;

        const aVisible = this.isImageValid(a.imageID);
        const bVisible = this.isImageValid(b.imageID);

        const aHasAnno = this.pr.relatedAnnotationList.some(el => el.image === a.filename);
        const bHasAnno = this.pr.relatedAnnotationList.some(el => el.image === b.filename);

        const aPriority =
          (aVisible ? 2 : 0) +   // Sichtbare Bilder bekommen 2 Punkte
          (aHasAnno ? 1 : 0);    // Annotationen +1 Punkt

        const bPriority =
          (bVisible ? 2 : 0) +
          (bHasAnno ? 1 : 0);

        // 2. Nach Priorität sortieren (Annotationen/Sichtbarkeit haben Vorrang)
        if (aPriority !== bPriority) return bPriority - aPriority;

        // 3. Nach imageSortInfo Rank sortieren, falls Priorität gleich ist
        const sortInfo = this.pr.imageSortInfo || {};

        // Wir setzen Bilder ohne definierten Rang ans Ende (Infinity)
        const aRank = sortInfo[a.imageID] !== undefined ? sortInfo[a.imageID] : Infinity;
        const bRank = sortInfo[b.imageID] !== undefined ? sortInfo[b.imageID] : Infinity;

        if (aRank !== bRank) {
          return aRank - bRank; // Aufsteigend: Niedrigerer Rank (z.B. 0) kommt zuerst
        }

        // 4. Fallback: alphabetisch, falls Ränge gleich sind oder beide keinen haben
        return a.filename.localeCompare(b.filename);
      });
      if (this.pr.cave.cave3DModel && this.isLocatedInCave){
        this.images.push({
          "imageID": "3D",
          "is3D": true
        })
      }
      const lksList = getLeipzigKuchastudiesEntries(this.pr.relatedBibliographyList)
      this.$log.debug("lksList", lksList)
      if (lksList.length > 0){
        this.$log.debug("has lksEntries", lksList)
        for (const lks of lksList){
          this.images.push({
            "isLKS": true,
            "LKS": lks
          })
          this.$log.debug("added lksEntry", this.images)
        }
      }
      this.$log.debug('this.images', this.images)
      this.annos.sort(function(a, b){return b.accessLevel - a.accessLevel})
    },
    setVersion(version){
      getVersionOfEntry(version._id)
        .then( res => {
          this.pr = res.data._source.content
        }).catch(function (error) {
          this.$log.debug(error)
          return null
        })
      const _self = this
      if (version.date.toString().includes('current')){
        this.wallTree = this.$store.state.wallLocation
        this.$log.debug("this.wallTree", this.wallTree);
        this.initWalls()
      } else {
        getWallTreeByTimestamp(this.version._source.timestamp)
          .then( res => {
            _self.$log.debug("recieved versions of wall.", res.data.hits.hits[0]._source.content.wallTree)
            _self.wallTree = res.data.hits.hits[0]._source.content.wallTree
            _self.initWalls()
          }).catch(function (error) {
            _self.$log.debug(error)
            return null
          })
      }
    }
  },
  watch: {
    image: {
      handler(newVal) {
        this.relatedDepictionsByImage = [] // Reset
        if (newVal && newVal.imageID && !newVal.is3D && !newVal.isLKS) {
          getDepictionsByImageID(newVal.imageID).then(res => {
            if (res.data && res.data.hits && res.data.hits.hits.length > 0) {
              // We do not need the current depiction in here. Filtered out.
              this.relatedDepictionsByImage = res.data.hits.hits
                .map(hit => hit._source)
                .filter(pr => pr.depictionID !== this.pr.depictionID)
              this.$log.debug("relatedDepictionsByImage", this.relatedDepictionsByImage)
            }
          }).catch(error => {
            this.$log.error("Fehler beim Laden der related PRs:", error)
          })
        }
      },
      immediate: true // Lädt auch beim ersten gesetzten Bild sofort
    },
    images: function(newVal, oldVal) {
      this.$log.debug("this.image changes", this.image)
    },

    user: {
      handler(val){
        this.$store.dispatch('buildImageValidDic', this.depiction.relatedImages)
      },
      deep: true
    },
    depiction:{
      handler(val){
        this.initNewDepiction()
        this.$store.dispatch('buildImageValidDic', val.relatedImages)
      },
      deep: true
    },
    'annos': function(newVal, oldVal) {
      this.$log.debug("this.annos", this.annos)
      this.$store.dispatch('buildImageValidDic', this.annos)
      if (this.isMounted){
        this.initNewAnnotatedImage(false)
      }
    },
    imageValidDic: {
      handler(val){
        this.tabKey += 1
        if (this.isMounted){
          this.$log.debug("imageValidDic,", this.imageValidDic);
          this.initNewAnnotatedImage(false)
        }

      },
      deep: true
    },
    relatedDepictions(newVal, oldVal){
      this.$log.debug("relatedDepictions", newVal)
      var image = null
      if (newVal.length > 0){
        var foundRelatedDepictionsTab = false
        for (image of this.images){
          if (image.isLinks){
            this.images.splice(this.images.indexOf(image), 1)
            break
          }
        }
      }
      this.$log.debug("recieved relatedDepictions", this.images)
    },

    version(newVal, oldVal){
      let versionNumber = this.versions.indexOf(newVal) + 1
      const routeVersionNumber = parseInt(this.$route.params.version) || this.versions.length - 1
      if (this.$route.params.version){
        if (versionNumber === this.versions.length){
          if (this.$route.params.version !== "current"){
            this.$router.push({
              name: 'Painted Representation',
              params: {
                id: this.$route.params.id,
                version: "current"
              }
            });
          }
        } else if (versionNumber !== routeVersionNumber){
          if (newVal != null){

            this.$router.push({
              name: 'Painted Representation',
              params: {
                id: this.$route.params.id,
                version: versionNumber
              }
            });
          }
        }
      }
    }
  },
  mounted:function () {
    this.$log.debug("new depiction started", this.$route);
    this.$store.dispatch('buildImageValidDic', this.annos)
    this.getRelatedDepictions()
    this.initNewDepiction()
    this.getComments()
    if (this.$refs['wallTree']) {
      this.$log.debug("this.$refs['wallTree']", this.$refs['wallTree']);
      this.$refs['wallTree'][0].updateAll(true)
    }
  },
  beforeMount:function(){
    this.pr = this.depiction
    if (this.$store.state.wallLocation.length === 0){
      this.$store.dispatch('getWallLocation')
    } else {
      this.walllocation = this.$store.state.wallLocation
    }
  }
}
</script>
<style lang="css" scoped>

.depiction-link {
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  color: rgba(0, 0, 0, 0.87);
  word-break: break-word;
}

.list-item-value {
  white-space: pre-line;
  padding-left: 10px;
}
.v-treeview {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 100% !important;
}
.hidden {
  visibility: hidden;
}

.visible {
  visibility: visible;
}
.no-background {
  background-color: transparent !important
}
#instructions {
  pointer-events: none!important;
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  font-size: 16px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sticky-header-bar {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: transparent!important;
  padding: 4px;
  border-bottom: 1px solid black;
}
.highlighted {
  position: relative;
  overflow: hidden;
}

.highlighted::after {
  content: "";
  position: absolute;
  inset: 0;
  background-color: var(--v-primary-base);
  opacity: 0;
  transition: opacity 0.6s ease-in-out;
  z-index: 2;
}

.highlighted-active::after {
  opacity: 0.4;
}
.list-item-value {
  white-space: pre-line;
}
.accordion-header {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 12px 0;
  user-select: none;
  font-weight: 600;
  color: #333;
}

.chevron {
  width: 20px;
  height: 20px;
  transition: transform 0.4s ease;
}

.chevron-open {
  transform: rotate(180deg);
}

.accordion-grid {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.8s ease-in-out;
}

.accordion-grid.is-open {
  grid-template-rows: 1fr;
}

.accordion-grid-inner {
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.6s ease-in-out 0.2s;
}

.accordion-grid.is-open .accordion-grid-inner {
  opacity: 1;
}
</style>